// Configuration file for Talsa locations
const locations = [
    {
        name: "Itagüí",
        address: "Carrera 49 No 51-63",
        city: "Itagüí, Antioquia",
        url: "https://www.google.com/maps/place/CI+Talsa+Medell%C3%ADn/@6.1967474,-75.5894503,17z/data=!4m5!3m4!1s0x8e46826fc2982a93:0xdd96fedde788b5c9!8m2!3d6.1967474!4d-75.5872616?shorturl=1"
    },
    {
        name: "Bogotá",
        address: "Calle 13 No 68G-31",
        city: "Bogotá D.C., Colombia",
        url: "https://www.google.com/maps/dir//4.6316945,-74.1238324/@4.631908,-74.123822,17z?hl=es"
    },
    {
        name: "Cali",
        address: "Carrera 1 #45a-71",
        city: "Cali, Valle del Cauca",
        url: "https://www.google.com/maps?ll=3.472033,-76.508979&z=16&t=m&hl=es&gl=CO&mapclient=embed&daddr=CI+Talsa+Cali+Cra.+1+%2345a71+Cali,+Valle+del+Cauca@3.472033,-76.50897859999999"
    },
    {
        name: "Barranquilla",
        address: "Calle 93 #46-168",
        city: "Barranquilla, Atlántico",
        url: "https://www.google.com/maps?ll=11.005717,-74.82637&z=16&t=m&hl=es&gl=CO&mapclient=embed&daddr=CI+Talsa+Barranquilla+Cl.+93+%23No+46+-+168+Barranquilla,+Atl%C3%A1ntico@11.0057165,-74.8263704"
    },
    {
        name: "Dosquebradas",
        address: "Carrera 20 #15-23",
        city: "Dosquebradas, Risaralda",
        url: "https://maps.app.goo.gl/33eXiLzLNAYC6AW6A"
    },
    {
        name: "Bucaramanga",
        address: "Carrera 27 #18-57",
        city: "Bucaramanga, Santander",
        url: "https://www.google.com/maps/dir//Cl+Talsa+Bucaramanga,+Cra.+27+%2318+-+57,+Bucaramanga,+Santander/@7.1302412,-73.1188509,18.79z/data=!4m8!4m7!1m0!1m5!1m1!1s0x8e681564c91101bd:0x993eb54990aa9772!2m2!1d-73.1195639!2d7.1308223?hl=es"
    },
    {
        name: "Cúcuta",
        address: "Av 0 #16-35",
        city: "Cúcuta, Norte de Santander",
        url: "https://www.google.com/maps/dir//7.8917008,-72.5021452/@7.891701,-72.502145,16z?hl=es"
    }
];

export default locations;
